export default {
  created: 'Ticket.field.created',
  ticketType: 'Ticket.field.ticketType',
  dueDate: 'Ticket.field.dueDate',
  ticketStatus: {
    label: 'Ticket.field.ticketStatus',
    OPEN: 'Ticket.field.ticketStatus.Open',
    RE_ASSIGNED: 'Ticket.field.ticketStatus.Reassigned',
    ASSIGNED: 'Ticket.field.ticketStatus.Assigned',
    CLOSED: 'Ticket.field.ticketStatus.Closed',
    REOPENED: 'Ticket.field.ticketStatus.Reopened'
  },
  ticketResolution: 'Ticket.field.ticketResolution',
  ticketDescription: 'TicketType.field.standardTicketDescription',
  ticketTitle: 'TicketType.field.standardTicketTitle',
  route: 'TicketDetails.generalSection.ticketLinked.route.label',
  stop: 'TicketDetails.generalSection.ticketLinked.location.label',
  driver: 'TicketDetails.generalSection.ticketLinked.user.label',
  attendant: 'Ticket.field.userAssigned',
  taskType: 'TicketDetails.field.taskType',
  commentModal: {
    newTitle: 'TicketDetails.section.comments.modalAddNewTitle',
    cancelButton: 'TicketDetails.section.comments.modalCancelButton',
    saveButton: 'TicketDetails.section.comments.modalSaveButton'
  },
  dataNotFound: 'TicketDetails.sections.dataNotFound',
  noTaskRelated: 'TicketDetails.sections.noTaskRelated',
  noComments: 'TicketDetails.sections.noComments',
  addedAComment: 'TicketDetails.section.comments.addedAComment',
  addCommentButton: 'TicketDetails.section.comments.addCommentBtn',
  commentSectionTitle: 'TicketDetails.section.comments.title',
  alertToDeleteCommentQuestion: 'TicketDetails.section.comments.wouldLikeToDelete',
  messageHistory: 'TicketDetails.section.attachments.chatTitle.messageHistory',
  ticketOpenedAt: 'TicketDetails.section.attachments.ticketOpenedAt',
  chatAt: 'TicketDetails.section.attachments.chat.at',
  ASSIGNED: 'TicketDetails.section.attachments.ticketChat.assigned',
  RE_ASSIGNED: 'TicketDetails.section.attachments.ticketChat.reassigned',
  noChatsToShow: 'TicketDetails.sections.attachments.noChatsToShow'
};
